import { render, staticRenderFns } from "./ComboboxPergunta.vue?vue&type=template&id=6eccd2fa"
import script from "./ComboboxPergunta.vue?vue&type=script&lang=js"
export * from "./ComboboxPergunta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports